import React from 'react'
import { CardModel } from 'mvppoker-portal-common/api'
import { R } from '../../../../R/R'
import { classNames } from '../../../../utils/cssUtils'
import './PokerCardView.scss'
import { getCardBackUrl, getCardUrl } from '../../../../logic/Decks'

interface Props {
	deck: number
	card?: CardModel
	back?: boolean
	slot?: boolean | 'blue'
	shadow?: boolean
	dealt?: boolean
}

export const PokerCardView = ({ deck, card, back, slot, shadow, dealt }: Props) => {
	let src: string | undefined

	if (back) {
		src = getCardBackUrl(deck)
	} else if (card) {
		src = getCardUrl(deck, card)
	}

	const cs = classNames('poker-card', {
		slot: slot === true,
		'blue-slot': slot === 'blue',
		'has-card': !!(card || back),
		'dark-shadow': !!shadow,
		dealt: !!dealt,
		'needs-dealing': dealt !== undefined,
	})
	// const classes = `poker-card ${slot ? 'slot' : ''} ${(card || back) ? 'has-card' : ''}`

	return (
		<div className={cs}>
			<img className='card-img' src={src} alt='poker card' />
			{slot === 'blue' && <img className='card-slot-icon' src={R.images.logoMvp} alt='' />}
		</div>
	)
}
